import { render, staticRenderFns } from "./elementCoordinates.vue?vue&type=template&id=22f79e22"
import script from "./elementCoordinates.ts?vue&type=script&lang=js&external"
export * from "./elementCoordinates.ts?vue&type=script&lang=js&external"
import style0 from "./elementCoordinates.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports